import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ThemesService from "../api/themes";
import TemplateTable from "../common/Layout/templatePages/templateTable";
import handleNavigate from "../common/customFunctions/handleNavigate";
import { useNavigate } from "react-router-dom";
import { setThemeApi } from "../store/themeApiSlice";

function THemesApiThemeTab() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const organziation = useSelector(({ organziation }) => organziation);
  const [loadingValue, setLoadingValue] = useState(true);
  const [thmes, setThemes] = useState([]);

  useEffect(() => {
    getThemes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getThemes() {
    console.log("getTags");
    setLoadingValue(true);
    const orgObj = JSON.parse(localStorage.getItem("defaultOrganization"));
    const apiKey =
      organziation?.api_key_list?.[0]?.key ?? orgObj?.api_key_list?.[0]?.key;

    ThemesService.getThemeProfile({
      theme_profile_id: "",
      apiKey,
    })
      .then((jsonCurrent) => {
        if (jsonCurrent?.theme_profile?.length) {
          setThemes(jsonCurrent?.theme_profile);
        }
        setLoadingValue(false);
      })
      .catch((errorr) => {
        if (process.env.NODE_ENV === "development")
          console.log("getUserTypePermissionserrorr", errorr);
      });
  }
  const handleButton = (event, buttonType, row) => {
    if (buttonType === "edit") {
      handleEditThemeApiProfile(event, row);
    }
  };
  const handleEditThemeApiProfile = (event, row) => {
    dispatch(
      setThemeApi({
        theme_id: row.theme_id,
        name: row.name,
        description: row.description,
        color: row.color,
        status: row.status,
      })
    );
    event.stopPropagation();
    handleNavigate(event, navigate, `/addEditThemeApi?id=${row.theme_id}`);
  };
  return (
    <>
      <TemplateTable
        headCells={[
          { id: "name", label: "Name" },
          { id: "description", label: "Description" },
          { id: "status", label: "Status" },
          {
            id: "action",
            buttons: ["edit"],
          },
        ]}
        handleButton={handleButton}
        itemsList={thmes}
        itemId="name"
        loading={loadingValue}
        searchAttributes={["name", "description"]}
        allowExport
        exportTitle={t("Themes")}
      />
    </>
  );
}

export default THemesApiThemeTab;
